import { render, staticRenderFns } from "./ButtonLabel.vue?vue&type=template&id=29622c59&"
import script from "./ButtonLabel.vue?vue&type=script&lang=ts&"
export * from "./ButtonLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports